import FileCopyIcon from "@mui/icons-material/FileCopy";
import ExploreIcon from "@mui/icons-material/Explore";
import DescriptionIcon from "@mui/icons-material/Description";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import {
  Dashboard as DashboardIcon,
  Analytics,
  Assignment as RequirementIcon,
} from "@mui/icons-material";
import { Public as PublicIcon } from "@mui/icons-material";
import {
  Inventory as ProductIcon,
  LocalOffer as OfferIcon,
  Business as EntityIcon,
  Visibility as ViewIcon,
  Add as AddIcon,
  QuestionAnswer as RFQIcon,
  Chat as CommunicationIcon,
  Support as SupportIcon,
  Settings as SettingsIcon,
} from "@mui/icons-material";
import DomainVerificationIcon from "@mui/icons-material/DomainVerification";
export const sidebar = {
  amtpl: [
    {
      name: "Dashboard",
      icon: <DashboardIcon />,
      link: "/amtpl/dashboard",
    },
    {
      name: "Master Data",
      icon: <ProductIcon />,
      path: "/amtpl/master",
    },
    // {
    //   name: 'Master Data',
    //   icon: <ProductIcon />,
    //   path: '/amtpla/master',
    //   submenu: [
    //     { name: 'Products', path: '/amtpla/products', icon: <PublicIcon /> },
    //     {
    //       name: 'Product Offers',
    //       label: 'Discover & Evaluate',
    //       path: '/amtpla/discoverevaluate',
    //       icon: <OfferIcon />,
    //       submenu: [
    //         // { name: 'Offers List', path: '/amtpla/offers', icon: <OfferIcon /> }
    //       ]
    //     },
    //     { name: 'Inland Shipping', label: 'Requirement', path: '/amtpla/requirement', icon: <LocalShippingIcon /> },
    //     { name: 'Country-wise Products', label: 'RFQs & Offers', path: '/amtpla/rfqoffers', icon: <PublicIcon /> },
    //   ],
    // },
    {
      name: "Entities",
      icon: <EntityIcon />,
      link: "/amtpl/entities",
    },
    {
      name: "Produce",
      icon: <PublicIcon />,
      link: "/amtpl/produce",
    },
    {
      name: "Offers",
      icon: <OfferIcon />,
      link: "/amtpl/offers",
    },

    {
      name: "Trade",
      icon: <RequirementIcon />,
      link: "/amtpl/trade",
    },
    // {
    //   name: "Document Vault",
    //   icon: <FolderOpenIcon />,
    //   link: "/amtpl/documentvault",
    // },
    {
      name: "KYB",
      icon: <DomainVerificationIcon />,
      link: "/amtpl/kyb",
    },
    {
      name: "KYC",
      icon: <DomainVerificationIcon />,
      link: "/amtpl/kyc",
    },
    {
      name: "Messaging",
      icon: <CommunicationIcon />,
      link: "/amtpl/messaging",
    },
    {
      name: "Support ",
      icon: <SupportIcon />,
      link: "/amtpl/support",
    },
    // {
    //   name: "Contact Support ",
    //   icon: <SupportIcon />,
    //   link: "/amtpl/support",
    // },
    {
      name: "Settings ",
      icon: <SettingsIcon />,
      link: "/amtpl/settings",
    },
    {
      name: "Analytics",
      icon: <Analytics />,
      link: "/amtpl/analytics",
    },
    // {
    //   name: 'Requirement Management',
    //   icon: <RequirementIcon />,
    //   submenu: [
    //     { name: 'View', path: '/amtpla/requirements/view', icon: <ViewIcon /> },
    //     { name: 'Edit', label: 'Discover & Evaluate', path: '/amtpla/requirements/edit', icon: <AddIcon /> },
    //   ],
    // },
  ],
};

export const sidebarProcurement = {
  amtpl_procurement: [
    {
      name: "Dashboard",
      icon: <DashboardIcon />,
      link: "/amtpl-procurement/dashboard",
    },
    {
      name: "Master Data",
      icon: <ProductIcon />,
      path: "/amtpl-procurement/master-data",
    },

    {
      name: "Documents Vault",
      icon: <FolderOpenIcon />,
      path: "/amtpl-procurement/project-documents",
      // submenu: [
      //   { name: 'All Documents', path: '/amtpl-procurement/project-documents', icon: <DescriptionIcon /> },
      // ],
    },
    {
      name: "Invoices",
      icon: <FolderOpenIcon />,
      path: "/amtpl-procurement/invoices",
      // submenu: [
      //   { name: 'All Invoices', path: '/amtpl-procurement/invoices', icon: <DescriptionIcon /> },
      // ],
    },
  ],
};
